// tslint:disable:variable-name

export enum UserRole {
    Admin = 'admin',
    Moderator = 'moder'
}

export class UserAccount {
    /* Identification */
    id?: string;
    email?: string;
    login: string;
    name: string;

    /* Activity tracking */
    create_time?: Date;
    deleted?: boolean;
    active?: boolean;

    /* User preferences */
    about?: string;
    time_zone?: string;
    language?: string;
    theme?: string;
    roles?: UserRole[];

    /* Custom fields */
    custom_hdr?: any;
    custom_dat?: any;

    /* Additional response field */
    password?: string;
}
